import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Title, Text, Stack, Card, Group, Switch, Badge } from '@mantine/core';
import { IconFlask } from '@tabler/icons-react';
import { FEATURE_FLAGS } from '../../config/featureFlags';
import { useFeatureFlagsStore } from '../../store/featureFlagsStore';

export const FeatureFlagsPage: React.FC = () => {
  const { t } = useTranslation();
  const enabled = useFeatureFlagsStore((s) => s.enabled);
  const toggleFeature = useFeatureFlagsStore((s) => s.toggleFeature);

  return (
    <Container size="sm" py="md">
      <Group gap="xs" mb="xs">
        <IconFlask size={24} />
        <Title order={2}>{t('featureFlags.title')}</Title>
      </Group>
      <Text c="dimmed" size="sm" mb="lg">
        {t('featureFlags.subtitle')}
      </Text>

      <Stack gap="sm">
        {FEATURE_FLAGS.length === 0 && (
          <Text c="dimmed" size="sm">
            {t('featureFlags.empty')}
          </Text>
        )}
        {FEATURE_FLAGS.map((f) => (
          <Card key={f.key} withBorder radius="md" padding="md">
            <Group justify="space-between" wrap="nowrap" align="flex-start">
              <div style={{ flex: 1 }}>
                <Group gap="xs" mb={4}>
                  <Text fw={600}>{t(f.titleKey)}</Text>
                  {f.comingSoon && (
                    <Badge size="sm" color="gray" variant="light">
                      {t('featureFlags.comingSoon')}
                    </Badge>
                  )}
                </Group>
                <Text c="dimmed" size="sm">
                  {t(f.descKey)}
                </Text>
              </div>
              <Switch
                checked={enabled[f.key] === true}
                onChange={() => toggleFeature(f.key)}
                disabled={f.comingSoon}
                aria-label={t(f.titleKey)}
              />
            </Group>
          </Card>
        ))}
      </Stack>
    </Container>
  );
};
